import { z } from 'zod';
/**
 * Payload shape for `GET /api/dashboard/per-location-revenue`.
 *
 * Comprehensive per-location revenue table — every location in
 * scope with its 7d or 30d revenue. Differs from
 * `/dashboard/top-revenue-locations` (which returns top 10
 * sorted desc): this widget shows ALL locations the caller can
 * see, intended for Building Admins / Property Managers who
 * want to scan revenue at each of their assigned buildings, not
 * just the leaderboard tip.
 *
 * Same aggregation shape as top-revenue-locations, no $limit.
 * Cached server-side per (tenant, range, scope-fingerprint).
 *
 * Sort: revenue_cents desc by default. Frontend doesn't re-sort.
 */
export const PerLocationRevenueRangeSchema = z.enum(['7d', '30d']);
export const PerLocationRevenueRowSchema = z.object({
    location_id: z.string(),
    location_name: z.string(),
    revenue_cents: z.number().int().nonnegative(),
    session_count: z.number().int().nonnegative(),
});
export const PerLocationRevenueResponseSchema = z.object({
    rows: z.array(PerLocationRevenueRowSchema),
    range: PerLocationRevenueRangeSchema,
    is_scoped: z.boolean(),
    generated_at: z.string(),
});
//# sourceMappingURL=dashboard-per-location-revenue.js.map